
export default class AddressModel {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.id = data.id || 0;
    this.street_address = data.street_address || '';
    this.street_address_line_2 = data.street_address_line_2 || '';
    this.locality = data.locality || '';
    this.region = data.region || '';
    this.postal_code = data.postal_code || '';
    this.country = data.country || '';
  }
}
